const getters = {
  name: state => state.common.name,
  userType: state => state.common.userType,
  user: state => state.common.user,
  baseUrl: state => state.common.baseUrl,
  dictTree: state => state.common.dictTree,
};
export default getters
